import * as c from './types';

import { OptionsDataState, WorkOrderShort } from 'ducks/workOrders/reducers';

import createReducer from '../../reducers/utils/createReducer';

export type SimpleWorkOrderNameState = OptionsDataState<WorkOrderShort>;

const initialState: SimpleWorkOrderNameState = {
  data: [],
  isLoading: false,
  totalItems: 0
};

export default createReducer(initialState, {
  [c.FETCH_SIMPLE_WORK_ORDER_NAME_REQUEST]: (state = initialState) => ({
    ...state,
    error: null,
    isLoading: true
  }),
  [c.FETCH_SIMPLE_WORK_ORDER_NAME_SUCCESS]: (
    state = initialState,
    { payload }
  ) => {
    if (!payload) return state;
    return {
      ...state,
      ...payload,
      error: null,
      isLoading: false
    };
  },
  [c.FETCH_SIMPLE_WORK_ORDER_NAME_ERROR]: (
    state = initialState,
    { payload }
  ) => {
    if (!payload) return state;
    return {
      ...state,
      error: payload,
      isLoading: false
    };
  }
});
